// Registers the container and all video UI custom elements
// without creating a skin element. Use this entry when building an ejected
// (light DOM) player layout.

import { I18nProviderElement } from '../../i18n/provider-element';
import { safeDefine } from '../../registration/safe-define';
import {
  defineControls,
  defineErrorDialog,
  defineInputIndicators,
  defineMenu,
  defineSliders,
  defineTime,
  defineTooltip,
} from '../../registration/ui-compounds';
import { AirPlayButtonElement } from '../../ui/airplay-button/airplay-button-element';
import { AudioTrackRadioGroupElement } from '../../ui/audio-track-radio-group/audio-track-radio-group-element';
import { BufferingIndicatorElement } from '../../ui/buffering-indicator/buffering-indicator-element';
import { CaptionsButtonElement } from '../../ui/captions-button/captions-button-element';
import { CaptionsRadioGroupElement } from '../../ui/captions-radio-group/captions-radio-group-element';
import { CastButtonElement } from '../../ui/cast-button/cast-button-element';
import { ContainerElement } from '../../ui/container/container-element';
import { FullscreenButtonElement } from '../../ui/fullscreen-button/fullscreen-button-element';
import { GestureElement } from '../../ui/gesture/gesture-element';
import { HotkeyElement } from '../../ui/hotkey/hotkey-element';
import { LiveButtonElement } from '../../ui/live-button/live-button-element';
import { MuteButtonElement } from '../../ui/mute-button/mute-button-element';
import { PiPButtonElement } from '../../ui/pip-button/pip-button-element';
import { PlayButtonElement } from '../../ui/play-button/play-button-element';
import { PlaybackRateButtonElement } from '../../ui/playback-rate-button/playback-rate-button-element';
import { PlaybackRateRadioGroupElement } from '../../ui/playback-rate-radio-group/playback-rate-radio-group-element';
import { PopoverElement } from '../../ui/popover/popover-element';
import { PosterElement } from '../../ui/poster/poster-element';
import { QualityRadioGroupElement } from '../../ui/quality-radio-group/quality-radio-group-element';
import { SeekButtonElement } from '../../ui/seek-button/seek-button-element';
import { TextElement } from '../../ui/text/text-element';
import { TimeSliderChapterTitleElement } from '../../ui/time-slider/time-slider-chapters/time-slider-chapter-title-element';
import { TimeSliderChaptersElement } from '../../ui/time-slider/time-slider-chapters/time-slider-chapters-element';

// ── Registration (providers / parents first) ────────────────────────────

safeDefine(ContainerElement);
safeDefine(I18nProviderElement);

// Compound groups.
defineControls();
defineErrorDialog();
defineInputIndicators();
defineSliders();
safeDefine(TimeSliderChaptersElement);
safeDefine(TimeSliderChapterTitleElement);
defineTime();
defineMenu();
defineTooltip();

// Standalone elements.
safeDefine(AirPlayButtonElement);
safeDefine(AudioTrackRadioGroupElement);
safeDefine(BufferingIndicatorElement);
safeDefine(CaptionsButtonElement);
safeDefine(CastButtonElement);
safeDefine(FullscreenButtonElement);
safeDefine(GestureElement);
safeDefine(HotkeyElement);
safeDefine(LiveButtonElement);
safeDefine(MuteButtonElement);
safeDefine(PiPButtonElement);
safeDefine(PlayButtonElement);
safeDefine(PlaybackRateButtonElement);
safeDefine(PlaybackRateRadioGroupElement);
safeDefine(CaptionsRadioGroupElement);
safeDefine(PopoverElement);
safeDefine(PosterElement);
safeDefine(QualityRadioGroupElement);
safeDefine(SeekButtonElement);
safeDefine(TextElement);
